import { action } from 'typesafe-actions';
import { IApiQueryOptions } from '../../api/ApiClient';
import { IApiList, IEmployer, IEmployerSite, ISite } from '../../types';
import { IEmployerState } from '../types';
import { Employers } from './types';

export const getEmployersRequest = () => action(Employers.GET_EMPLOYERS_REQUEST);
export const getEmployersSuccess = (response: Record<string, IEmployerState>) => action(Employers.GET_EMPLOYERS_SUCCESS, response);
export const getEmployersError = (error: any) => action(Employers.GET_EMPLOYERS_FAIL, error);

export const getActionRequiredEmployersRequest = (onSuccess: (response: Array<IEmployerSite | IEmployer>) => void) => action(Employers.GET_ACTION_REQUIRED_EMPLOYERS_REQUEST, { onSuccess });
export const getActionRequiredEmployersSuccess = (response: Array<IEmployerSite | IEmployer>) => action(Employers.GET_ACTION_REQUIRED_EMPLOYERS_SUCCESS, response);
export const getActionRequiredEmployersError = (error: any) => action(Employers.GET_ACTION_REQUIRED_EMPLOYERS_FAIL, error);

export const getEmployerSitesRequest = (orgId: string, onSuccess: (response: IApiList<ISite>) => void, options?: IApiQueryOptions) => action(Employers.GET_EMPLOYER_SITES_REQUEST, { orgId, onSuccess, options });
export const getEmployerSitesSuccess = (response: IApiList<ISite>) => action(Employers.GET_EMPLOYER_SITES_SUCCESS, response);
export const getEmployerSitesError = (error: any) => action(Employers.GET_EMPLOYER_SITES_FAIL, error);
